export default {
  userName: state => state.userName,
  access_token: state => state.access_token,
  refresh_token: state => state.refresh_token,
  expires_in: state => state.expires_in,
  Nome: state => state.Nome
}
